<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/v9DYKa/tc-custom/9781467465571.jpg?1734322800095" alt="This image is the cover for the book The Book of Jeremiah, Eerdmans Classic Biblical Commentaries (ECBC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Book of Jeremiah, Eerdmans Classic Biblical Commentaries (ECBC)
      </h1>
      <p class="bookDescription body article font2">
        <p>The Old Testament prophets played a crucial role in the history of Israel. Although there were many prophets who brought the message of God to his people, we have records</p><p>of only a few. Of these, our knowledge of Jeremiah is probably the most complete. In this commentary for scholars and pastors, originally part of the New International Commentary on the Old Testament, J. A. Thompson examines the book of Jeremiah with its message urging the people of Israel to be true to their covenant Lord and to live in conformity with his covenant requirements. </p><p>Thompson begins his study by looking at the role of the prophets in Israel and at Jeremiah’s place among them. He then discusses the historical setting of Jeremiah’s message. From this background, Thompson moves to an examination of the book of Jeremiah itself, focusing on its structure and composition before considering some important issues for exegesis—the date of Jeremiah’s call, the significance of the symbolic actions he performed, and the relationship between Jeremiah and Hosea. In the last part of his extensive introduction, Thompson examines the text and poetic forms of Jeremiah.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. A. Thompson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76860204